'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (input) {
  return input.replace(/\(r\)/gim, '®');
};

module.exports = exports['default'];

